import {Component, Injector, Input} from '@angular/core';
import {BasePageComponent} from '../../../../base/components/base-page.component';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-setting-layout',
  templateUrl: './setting-layout.component.html',
  styleUrls: ['./setting-layout.component.scss']
})
export class SettingLayoutComponent extends BasePageComponent {

  @Input() configForm: FormGroup;
  layoutFg: FormGroup;

  constructor(injector: Injector, private fb: FormBuilder) {
    super(injector);
  }

  ngOnDestroyForChildren(): void {
  }

  ngOnInitForChildren(): void {
    this.createForm();
  }

  pageName(): string {
    return 'SettingLayoutComponent';
  }

  createForm() {
    this.configForm = this.configForm ? this.configForm : this.fb.group({});

    this.layoutFg = this.layoutFg ? this.layoutFg : this.fb.group({});

    this.layoutFg.addControl('accordionsOpen', new FormControl({
      value: this.settingService.setting?.layout?.allAccordionOpen,
      disabled: this.settingService.setting?.layout?.tabMode
    }));

    this.layoutFg.addControl('tabMode', new FormControl(
      this.settingService.setting?.layout?.tabMode
    ));

    this.layoutFg.addControl('minimizedReview', new FormControl(
      this.settingService.setting?.layout?.minimizedReview
    ));

    this.layoutFg.addControl('expandedMenu', new FormControl(
      this.settingService.setting?.layout?.expandedMenu
    ));

    this.configForm.addControl('layout', this.layoutFg);

    this.configForm.markAsPristine();
  }

  onModeChange() {
    if (this.configForm.get('layout').get('tabMode').value === true) {
      this.configForm.get('layout').get('accordionsOpen').setValue(false);
      this.configForm.get('layout').get('accordionsOpen').disable();
      this.configForm.get('layout').get('accordionsOpen').updateValueAndValidity();
    } else {
      this.configForm.get('layout').get('accordionsOpen').setValue(this.settingService.setting?.layout?.allAccordionOpen);
      this.configForm.get('layout').get('accordionsOpen').enable();
      this.configForm.get('layout').get('accordionsOpen').updateValueAndValidity();
    }
  }
}
